import { Node } from '@tiptap/core';

/**
 * Quebra de página dentro do documento.
 * Na tela vira uma divisória com o rótulo "Página N"; na impressão/PDF
 * força o início de uma folha nova. É opcional: quem não inserir nenhuma,
 * segue com o documento corrido.
 */
export const PageBreak = Node.create({
  name: 'pageBreak',
  group: 'block',
  atom: true,
  selectable: true,

  parseHTML() {
    return [{ tag: 'div[data-quebra-pagina]' }];
  },

  renderHTML() {
    return ['div', { 'data-quebra-pagina': 'true', class: 'wiki-quebra-pagina' }];
  },

  addCommands() {
    return {
      insertPageBreak:
        () =>
        ({ chain }) =>
          chain()
            .focus()
            .insertContent({ type: this.name })
            // deixa um parágrafo pronto para digitar na página nova
            .insertContent({ type: 'paragraph' })
            .run(),
    };
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Enter': () => this.editor.commands.insertPageBreak(),
    };
  },
});

export default PageBreak;
